<template>
    <div>
        <b-card :header="$t('general.welding.documentation.title_welding_doc_overview_welding_status')" header-tag="h3" class="bg-default-card">
            <data-table
                v-if="tableLoaded"
                :exportable="false"
                title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"

                :grandTotal="true"
                :grandTotalData="getData.grandTotal"

                @changePage="changePage"
                @searchEvent="searchEvent"
                @orderByEvent="orderByEvent"
                >
            </data-table>
        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DataTable from '@/components/global/tables/datatables/DataTable.vue';
    import http from '@/libs/http';

    import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
    import miniToastr from 'mini-toastr';

    export default {
    name: 'weldingstatus1',
    components: {
        DataTable,
        notificationIcons
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('general.administrative.messages.title_modal'),
            tableName: 'weld',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            filterByStatus: '',
            actionTitle: '',
            getData: {
                rowData: [],
                grandTotal: {}
            },
            columnData: [
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.field_area'),//+grand total
                    field: 'field_area',
                    numeric: false,
                    html: false,
                },

                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_dia_inch'),//G
                    field: 'total_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_dia_inch_prefab'),
                    field: 'total_dia_inch_prefab',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_dia_inch_erection'),
                    field: 'total_dia_inch_erection',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_dia_inch'),//J
                    field: 'current_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),
                    field: 'current_pc_finished',
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_dia_inch_prefab'),
                    field: 'current_dia_inch_prefab',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),
                    field: 'current_pc_finished2',
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_dia_inch_erection'),
                    field: 'current_dia_inch_erection',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),
                    field: 'current_pc_finished3',
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_bw_dia_inch'),//B
                    field: 'total_bw_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_bw_prefab_dia_inch'),//D
                    field: 'total_bw_prefab_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_bw_erection_dia_inch'),//F
                    field: 'total_bw_erection_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_bw_dia_inch'),//A
                    field: 'current_bw_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),//A / B
                    field: 'current_bw_dia_inch_pc',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_bw_prefab_dia_inch'),//C
                    field: 'current_bw_prefab_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),//C / D
                    field: 'current_bw_prefab_dia_inch_pc',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.total_bw_erection_dia_inch'),//E
                    field: 'current_bw_erection_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.current_pc_finished'),//E / F
                    field: 'current_bw_erection_dia_inch_pc',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.average_size_all_welds'),//G / total nb of welds
                    field: 'average_size_all_welds',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.average_size_bw_welds'),//B / total number of bw welds
                    field: 'average_size_bw_welds',
                    numeric: false,
                    html: false,
                    width:'90px',
                },

                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'progress_status',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_welds'),//H
                    field: 'repair_total_welds',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_welds_total_welds_tested'),//H / total current welds (1)
                    field: 'pc_repair_welds_total_welds_tested',//repair_welds_total_welds
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_dia_inch'),//I
                    field: 'repair_total_dia_inch',
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_total_dia_inch_total_dia_inch_tested'),//I / J
                    field: 'pc_repair_total_dia_inch_total_dia_inch_tested',//repair_dia_inch_total_dia_inch
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_welds_rt'),//K
                    field: 'repair_total_bw_welds_rt',//repair_total_bw_welds
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_rt_repair_total_bw_welds_total_bw_tested_rt'),//K / total current bw (1)
                    field: 'pc_rt_repair_total_bw_welds_total_bw_tested_rt',//repair_bw_welds_total_bwh
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_dia_inch_rt'),//L
                    field: 'repair_total_bw_dia_inch_rt',//repair_total_bw_dia_inch
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_rt_repair_total_bw_dia_inch_total_bw_dia_inch_rt_tested'),//L / A
                    field: 'pc_rt_repair_total_bw_dia_inch_total_bw_dia_inch_rt_tested',//repair_bw_dia_inch_total_bw_dia_inch
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_prefab_welds_rt'),//M
                    field: 'repair_total_bw_prefab_welds_rt',//repair_total_bw_prefab_welds
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_total_bw_prefab_welds_total_bw_prefab_tested_rt'),//M / total current bw prefab (1)
                    field: 'pc_repair_total_bw_prefab_welds_total_bw_prefab_tested_rt',//repair_bw_prefab_welds_total_bw_prefab
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_prefab_dia_inch_rt'),//N
                    field: 'repair_total_bw_prefab_dia_inch_rt',//repair_total_bw_prefab_dia_inch
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_total_bw_prefab_dia_inch_total_bw_prefab_dia_inch_tested_rt'),//N / C
                    field: 'pc_repair_total_bw_prefab_dia_inch_total_bw_prefab_dia_inch_tested_rt',//repair_bw_prefab_dia_inch_total_bw_prefab_dia_inch
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_erection_welds_rt'),//O
                    field: 'repair_total_bw_erection_welds_rt',//repair_total_bw_erection_welds
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_total_bw_erection_welds_total_bw_erection_welds_tested_rt'),//O / total current (1)
                    field: 'pc_repair_total_bw_erection_welds_total_bw_erection_welds_tested_rt',//repair_bw_erection_welds_total_bw_erection_welds
                    numeric: true,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.repair_total_bw_erection_dia_inch_rt'),//P
                    field: 'repair_total_bw_erection_dia_inch_rt',//repair_total_bw_erection_dia_inch
                    numeric: false,
                    html: false,
                    width:'90px',
                },
                {
                    label: Vue.i18n.translate('general.welding.weld.stats_table.pc_repair_total_bw_erection_dia_inch_total_bw_erection_dia_inch_tested_rt'),//P / E
                    field: 'pc_repair_total_bw_erection_dia_inch_total_bw_erection_dia_inch_tested_rt',//repair_total_bw_erection_dia_inch_total_bw_erection_dia_inch
                    numeric: true,
                    html: false,
                    width:'90px',
                },

            ]
        }
    },
    mounted () {
        this.onLoadTable();
    },
    methods: {
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route('drawing?filters[parent_drawing_id]=null&filters[welding_documentation]=2&project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[discipline_id]=1').get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;

                    if (typeof response.other != 'undefined') {
                        if (typeof response.other.grand_total != 'undefined') {
                            this.getData.grandTotal = response.other.grand_total;
                        }
                    }

                    data.forEach(field => {
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/project/welding/welding_documentation/weldingstatus1.vue